import { FirebaseApp, getApp, getApps, initializeApp } from 'firebase/app'
import { getRemoteConfig, RemoteConfig } from 'firebase/remote-config'

const isBrowser = typeof window !== 'undefined'

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
}

export const firebaseRemoteConfigDefaults = {
  record_sessions_percent: 0,
  record_heatmap_data: true,
  eligible_app_sources: JSON.stringify(['agc-dehaat', 'kisan-app']),
  complete_self_ordering_flow: true,
  atc_to_checkout: true,
  checkout: true,
  search: true,
  enable_new_search: true,
} as const

const isFirebaseConfigValid = () =>
  Boolean(
    firebaseConfig.apiKey &&
      firebaseConfig.authDomain &&
      firebaseConfig.projectId &&
      firebaseConfig.appId,
  )

export const isFirebaseRemoteConfigEnabled = () =>
  isBrowser && isFirebaseConfigValid()

let remoteConfig: RemoteConfig | undefined

if (isFirebaseRemoteConfigEnabled()) {
  try {
    const app: FirebaseApp = getApps().length
      ? getApp()
      : initializeApp(firebaseConfig)
    remoteConfig = getRemoteConfig(app)
    remoteConfig.settings.minimumFetchIntervalMillis = 15 * 60 * 1000
    remoteConfig.defaultConfig = { ...firebaseRemoteConfigDefaults }
  } catch (error) {
    console.warn('Firebase Remote Config unavailable:', error)
    remoteConfig = undefined
  }
} else if (isBrowser && !isFirebaseRemoteConfigEnabled()) {
  console.warn(
    'Firebase env vars are missing; Remote Config and Mixpanel session replay are disabled locally.',
  )
}

export { remoteConfig }
